import { useT } from '../i18n/useT';
import { footer as footerEn } from '../i18n/translations/en';
import { footer as footerEs } from '../i18n/translations/es';
import './Footer.css';

const footerLinks = [
    { href: '#why-venus' },
    { href: '#site-selection' },
    { href: '#business-resources' },
    { href: '#space' },
    { href: '#about-us' },
];

const Footer = () => {
    const t = useT({ en: footerEn, es: footerEs });
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-grid">
                    <div className="footer-brand">
                        <h2 className="footer-logo">Venus<span>EDC</span></h2>
                        <p className="footer-desc">{t.tagline}</p>
                        <div className="social-links">
                            <a href="#fb" className="social-icon">FB</a>
                            <a href="#tw" className="social-icon">TW</a>
                            <a href="#li" className="social-icon">IN</a>
                        </div>
                    </div>
                    <div className="footer-links">
                        <h3 className="footer-heading">{t.quickLinks}</h3>
                        <ul>
                            {footerLinks.map((l, i) => (
                                <li key={i}><a href={l.href}>{t.links[i]}</a></li>
                            ))}
                        </ul>
                    </div>
                    <div className="footer-contact">
                        <h3 className="footer-heading">{t.contactUs}</h3>
                        <p>105 E. Highway 67<br />Venus, TX 76084</p>
                        <p>Phone: (972) 366-3348</p>
                        <p>Email: contact@venustxedc.com</p>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>&copy; {new Date().getFullYear()} {t.allRights}</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
